import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "carSegmentKeyPipe",
  standalone: true
})
export class CarSegmentKeyPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return "";
    const normalized = value.trim().toUpperCase().replace(/\s+/g, "_");
    return `time-selection.ebu.segments.${normalized}`;
  }
}
